import { useMemo } from 'react';
import { costFormater, useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT, RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

interface Response {
  invoice_close_date?: string;
  invoice_amount?: number;
}
const QUERY_KEY = 'REPLENISHMENT_INVOICE_BRIEF';
const useReplenishmentInvoiceBriefQuery = () => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY],
    // TODO: fix type
    () => api.get<Response>(API_URL.REPORTS_REPLENISHMENT_INVOICE_REPORT_BRIEF),
    {
      cacheTime: 0,
    }
  );

  const formattedDate = useMemo(() => {
    const response = data?.data;
    const currentDate = response?.invoice_close_date;
    const formattedCurrentDate = currentDate
      ? dayjs(currentDate, RAW_DATE_FORMAT).format(DEFAULT_DATE_FORMAT)
      : '';
    return formattedCurrentDate;
  }, [data?.data]);

  const formattedAmount = useMemo(() => {
    const response = data?.data;
    const amount = response?.invoice_amount;
    return amount
      ? costFormater(amount, {
          isPrecision: true,
        })
      : null;
  }, [data?.data]);
  return {
    isLoading,
    amount: formattedAmount,
    date: formattedDate,
  };
};

export default useReplenishmentInvoiceBriefQuery;
